import React, { useState } from 'react'
import { Tabs } from 'antd'
import { browserHistory } from 'react-router'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { FINANCE_PATH } from '../../constants'
import { replaceOwnedQuery } from '../../components/ReconciliationV2/replaceOwnedQuery'
import MonthlySummaryTab from './MonthlySummaryTab'
import AnnualSummaryTab from './AnnualSummaryTab'

type ReportTab = 'monthly' | 'annual'

const parseTab = (value: unknown): ReportTab =>
  value === 'annual' ? 'annual' : 'monthly'

/**
 * Reconciliation Reports: the Monthly Summary (one coverage month, expected vs
 * actual by source) and the Annual Summary (Finance's year spreadsheet). The
 * open tab rides `?tab=` so a link opens the same view.
 */
export default function ReconciliationV2Reports() {
  const [activeTab, setActiveTab] = useState<ReportTab>(() => {
    const query = browserHistory.getCurrentLocation().query as
      | Record<string, unknown>
      | undefined
    return parseTab(query?.tab)
  })

  const changeTab = (key: string) => {
    const tab = parseTab(key)
    setActiveTab(tab)
    replaceOwnedQuery(['tab'], tab === 'monthly' ? {} : { tab })
  }

  return (
    <PageWrapper>
      <Page
        title="Reconciliation Reports"
        maxWidth="1600px"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: FINANCE_PATH },
              {
                title: 'Payment Reconciliation',
                path: `${FINANCE_PATH}/payment-reconciliation-v2`,
              },
              { title: 'Reports' },
            ]}
          />
        }
      >
        <Tabs
          activeKey={activeTab}
          onChange={changeTab}
          destroyInactiveTabPane
          items={[
            {
              key: 'monthly',
              label: 'Monthly Summary',
              children: <MonthlySummaryTab />,
            },
            {
              key: 'annual',
              label: 'Annual Summary',
              children: <AnnualSummaryTab />,
            },
          ]}
        />
      </Page>
    </PageWrapper>
  )
}
